function log(...args) {
  console.log("[Omega]", ...args);
}
function warn(...args) {
  console.warn("[Omega]", ...args);
}
function checkEnabled(expressions, ns) {
  let enabled = false;
  for (const expr of expressions.split(",")) {
    const pattern = new RegExp(`^${expr.replace(/^-/, "").replace(/\*/g, ".*")}$`);
    if (pattern.test(ns)) {
      enabled = !expr.startsWith("-");
    }
  }
  return enabled;
}
function getDebug(ns) {
  function ret(...args) {
    if (ret.enabled) {
      console.debug("🐞", ns, ...args);
    }
  }
  Object.defineProperty(ret, "enabled", {
    get() {
      var _a, _b, _c;
      return checkEnabled(
        ((_a = globalThis.localStorage) == null ? void 0 : _a.getItem("debug")) ?? ((_c = (_b = globalThis.process) == null ? void 0 : _b.env) == null ? void 0 : _c.DEBUG) ?? "",
        ns
      );
    }
  });
  ret.extend = (subns) => getDebug(`${ns}:${subns}`);
  return ret;
}
const debug = getDebug("omega");
export {
  debug,
  log,
  warn };
//# sourceMappingURL=dist/log.js.map